module.exports = __webpack_public_path__ + "img/home_menu_7_selected.86137237.png";